import styled from 'styled-components/macro';

export const WidgetWrapper = styled.div`
    margin-top: var(--space-sm);
`;

export const ChartWrapper = styled.div``;
